export default "__VITE_ASSET__D8oysH3i__"